import React, { useState } from 'react';

import { Button, SvgImage, TextInput } from '../../../../../shared/components';
import { toSsoPassport } from '../../../../../shared/features/user';
import { i18n } from '../../../../../shared/helpers/i18n';
import { useActions } from '../../../../../shared/hooks';
import classes from './styles.css';

const ICON_SIZE = 48;

export const OverlayChangeAccount = () => {
    const actions = useActions({ toSsoPassport });
    const [email, setEmail] = useState('');

    const changeAccount = (event: React.FormEvent) => {
        event.preventDefault();

        if (!email) {
            return;
        }

        actions.toSsoPassport({ login: email });
    };

    return (
        <form onSubmit={changeAccount} className={classes.overlayChangeAccountContainer}>
            <span className={classes.icon}>
                <SvgImage style={{ width: ICON_SIZE, height: ICON_SIZE }} imageName="warningInCircle" />
            </span>
            <span className={classes.message}>{i18n('call', 'sso-account-suggest')}</span>
            <TextInput
                className={classes.input}
                size="md"
                type="email"
                placeholder="user@yandex-team.ru"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
            />
            <Button view="neutral" size="md" onClick={changeAccount} type="submit">
                {i18n('common', 'login')}
            </Button>
        </form>
    );
};
